// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qo-1";
export var stateContainer = "_qo-0";